import { useMemo, useState } from "react";
import { formatDateLocal } from "./financeUtils";

export default function useFinanceTransactionFilters({ departmentFilteredTransactions }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("전체");

  const currentDateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;

  const currentMonthTransactions = useMemo(() => {
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();
    return departmentFilteredTransactions
      .filter((transaction) => {
        const date = new Date(transaction.date);
        return date.getMonth() === month && date.getFullYear() === year;
      })
      .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id);
  }, [departmentFilteredTransactions, currentDate]);

  const filteredTransactions = useMemo(() => {
    let result = currentMonthTransactions;
    if (selectedDate) {
      const selectedDateStr = formatDateLocal(selectedDate);
      result = result.filter((transaction) => transaction.date === selectedDateStr);
    }
    if (selectedCategory !== "전체") {
      result = result.filter((transaction) => transaction.category === selectedCategory);
    }
    return result;
  }, [currentMonthTransactions, selectedDate, selectedCategory]);

  const availableCategories = useMemo(() => {
    const categories = new Set(currentMonthTransactions.map((transaction) => transaction.category));
    return ["전체", ...Array.from(categories)];
  }, [currentMonthTransactions]);

  const handlePrevMonth = () => {
    setCurrentDate((prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
    setSelectedDate(null);
  };

  const handleNextMonth = () => {
    setCurrentDate((prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
    setSelectedDate(null);
  };

  const handleToday = () => {
    const today = new Date();
    setCurrentDate(today);
    setSelectedDate(today);
  };

  const handleDateChange = (dateStr) => {
    const newDate = new Date(dateStr);
    setCurrentDate(newDate);
    setSelectedDate(newDate);
  };

  return {
    availableCategories,
    currentDate,
    currentDateStr,
    currentMonthTransactions,
    filteredTransactions,
    handleDateChange,
    handleNextMonth,
    handlePrevMonth,
    handleToday,
    selectedCategory,
    selectedDate,
    setSelectedCategory,
    setSelectedDate,
  };
}
